<script setup>
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { loadAnalytics } from "../utils/analytics";

const route = useRoute();
const choice = ref("loading");
const locale = computed(() => ["es", "en", "it"].includes(route.params.locale) ? route.params.locale : "es");
const translations = {
  es: {
    title: "Medición con criterio",
    body: "Usamos Analytics únicamente con tu permiso para entender qué contenido resulta útil.",
    accept: "Aceptar analítica",
    reject: "Sólo necesarias",
  },
  en: {
    title: "Thoughtful measurement",
    body: "We use Analytics only with your permission to learn which content is useful.",
    accept: "Accept analytics",
    reject: "Necessary only",
  },
  it: {
    title: "Misurazione consapevole",
    body: "Usiamo Analytics solo con il tuo consenso per capire quali contenuti sono utili.",
    accept: "Accetta analytics",
    reject: "Solo necessari",
  },
};
const copy = computed(() => translations[locale.value]);

onMounted(() => {
  choice.value = localStorage.getItem("resi-analytics-consent") || "";
  if (choice.value === "accepted") loadAnalytics();
});

function decide(value) {
  localStorage.setItem("resi-analytics-consent", value);
  choice.value = value;
  if (value === "accepted") loadAnalytics();
}
</script>

<template>
  <aside v-if="choice === ''" class="consent-banner" :aria-label="copy.title">
    <div>
      <strong>{{ copy.title }}</strong>
      <p>{{ copy.body }}</p>
    </div>
    <div class="consent-actions">
      <button type="button" class="button button--primary button--small" @click="decide('accepted')">
        {{ copy.accept }}
      </button>
      <button type="button" class="text-button" @click="decide('rejected')">{{ copy.reject }}</button>
    </div>
  </aside>
</template>
